import api, { addHeaderAuthorization } from './Api';
import { AUTH_TOKEN_KEY, GO_API_BASE_URL } from '../constants';

// Export traffic goes to the Kard Go backoffice, never to the Laravel pods:
// the download walk pages Go's /admins/sells, the email job runs in Go.
export const EXPORT_REQUEST_TIMEOUT_MS = 30000;

export const goClient = () => {
  const client = api(addHeaderAuthorization(localStorage.getItem(AUTH_TOKEN_KEY)), GO_API_BASE_URL);
  client.defaults.timeout = EXPORT_REQUEST_TIMEOUT_MS;
  return client;
};

// isRequestError tells an HTTP failure (status or no response) from a bug in
// our own code, which must stay visible instead of becoming "try again".
export const isRequestError = err => Boolean(err && (err.response || err.request || err.code === 'ECONNABORTED'));

export const countRows = (client, url, params) =>
  client.get(url, { params: { ...params, per_page: 1, page: 1, without_append: 1 } })
    .then(res => {
      const body = res.data && res.data.data;
      return body && body.total !== undefined ? body.total : 0;
    });

export const requestEmailExport = (client, kind, filters, columns) =>
  client.post(`/admins/exports/${kind}`, { filters, columns }).then(res => res.data.data);

export const loadLanguages = (client, categoryId) =>
  client.get('/admins/productvariants/languages', { params: { category_id: categoryId } })
    .then(res => (res.data && res.data.data) || []);

export const exportStatus = (client, id) =>
  client.get(`/admins/exports/${id}`).then(res => res.data.data);

// v2: values are arrays of { id, name } since the checklist boxes; v1 presets
// held scalars and are left where they are.
const presetKey = screen => `export_presets_v2_${screen}`;

export const loadPresets = screen => {
  try {
    const raw = localStorage.getItem(presetKey(screen));
    const list = raw ? JSON.parse(raw) : [];
    return Array.isArray(list) ? list : [];
  } catch (e) {
    return [];
  }
};

export const savePresets = (screen, presets) => {
  try {
    localStorage.setItem(presetKey(screen), JSON.stringify(presets));
  } catch (e) {
    // storage full or blocked: presets are a convenience, the export still works
  }
};
